<ng-template [ngIf]="formSole24Ore">
  <form [formGroup]="formSole24Ore" (ngSubmit)=cerca();>
    <div class="row">
      <p class="col-sm-12">
        <label for="cerca-sole24">Parole da cercare</label> <input class="form-control" id="cerca-sole24" placeholder="Inserisci"
          [(ngModel)]="request.searchText" [ngModelOptions]="{standalone: true}" type="text">
      </p>
    </div>
    <div class="row container_fieldset">
      <fieldset class="form-group">
        <legend>Fonte</legend>
        <div class="row" style="padding-bottom: 10px;">
          <div class="col-sm-4" *ngFor= "let item of fonti; let i = index">
            <p class="active singlecheckbox radiobutton dati_generali">
              <input name="fontiLIst" id="{{'fonte'+i}}" type="radio" [checked]="item.codice === request.fonte" (change)="changeStato(item.codice, false)">
              <label style="padding-right: 10px; font-weight: bold!important;"for="{{'fonte'+i}}">{{item.descrizione}}</label> 
            </p>
          </div>
        </div>
        <div class="row">
          <div ng-select-combo class="col-sm-12" *ngIf="request.fonte === '3'" formControlName="organo"
            [label]="'Organo'" [options]="organoOptions" [optionSel]="request.organo"
            (onChangeSel)="request.organo = $event;" [optionLabel]="'descrizione'"></div>
        </div>
      </fieldset>
    </div>
    <div class="row container_fieldset" *ngIf="request.fonte">
      <fieldset class="form-group">
        <legend>Estremi</legend>
        <div class="row">
          <!--<div comboModInput class="col-sm-12" *ngIf="request.fonte === 'legge' || request.fonte === 'prassi'"
					[labelInput]="'Ambito'" formControlName="ambito"
					[control]="formSole24Ore.controls['ambito']"
					[objectReference]="ambitoSlezionato"
					(onReturn)="ambitoSlezionato = $event" 
					[optionsCombo]="ambitiOptions"></div>-->
          <div datePickerInput [class]="request.fonte === '3' ? 'col-sm-4' : 'col-sm-3'" [labelInput]="'Data da'"
            [(ngModel)]="request.dataDa" formControlName="dataDal" [dataAl]="today"></div>
          <div datePickerInput [class]="request.fonte === '3' ? 'col-sm-4' : 'col-sm-3'" [labelInput]="'Data a'"
            [(ngModel)]="request.dataA" [dataDal]="request.dataDa" [dataAl]="today" formControlName="dataA"></div>
          <div naturalNumberInput [control]="formSole24Ore.controls['numero']" formControlName="numero"
            [class]="request.fonte === '3' ? 'col-sm-4' : 'col-sm-3'" [(ngModel)]="request.numero"
            [labelInput]="'Numero'"></div>
          <div *ngIf="request.fonte != '3'" naturalNumberInput [control]="formSole24Ore.controls['articolo']"
            [labelInput]="'Articolo'" formControlName="articolo" class="col-sm-3" [(ngModel)]="request.articolo"></div>
        </div>
        <!--<div class="row">
        <div comboModInput class="col-sm-3" *ngIf="request.fonte != 'giurisprudenza'"
        [labelInput]="'BIS, TER...'" formControlName="bis"
        [control]="formSole24Ore.controls['bis']"
        [objectReference]="bisSelezionato"
        (onReturn)="bisSelezionato = $event" 
        [optionsCombo]="bisOptions"></div>
      </div>-->
        <div class="row">
          <div ng-select-combo class="col-sm-12" formControlName="provvedimento" [label]="'Tipologia di provvedimento'"
            [options]="provvedimentoOptions" [optionSel]="request.provvedimento"
            (onChangeSel)="request.provvedimento = $event;" [optionLabel]="'descrizione'"></div>
          <!--<div comboModInput class="col-sm-12"
        [labelInput]="'Tipologia di provvedimento'" formControlName="provvedimento"
        [control]="formSole24Ore.controls['provvedimento']"
        [objectReference]="request.provvedimento"
        (onReturn)="request.provvedimento = $event" [labelOption]="'descrizione'"
        [optionsCombo]="provvedimentoOptions"></div>-->
        </div>
      </fieldset>
    </div>
    <div class="row">
      <p submitButton class="col-sm-3 col-xs-3 col-xs-offset-6 col-sm-offset-6" [labelButton]="'Cerca'"></p>
      <p class="col-sm-3 col-xs-3">
        <button type="button" class="btn btn-outline-secondary btn-block" (click)="reset()">Reset</button>
      </p>
    </div>
  </form>

  <ng-template [ngIf]="sole24OreResponse && sole24OreResponse.documents.length > 0">
    <ul id="documentocollapse" class="controparti">
      <ng-template ngFor let-documento [ngForOf]="sole24OreResponse.documents" let-i=index>
        <li class="panel">
          <div class="controparte">
            <div class="row" style="padding-right: 60px; padding-top: 10px;">
              <a *ngIf="!documento.url" [attr.data-toggle]="'collapse'" href="#subdocumento{{i}}" aria-expanded="false"
              [attr.aria-controls]="'subdocumento'+i" [attr.data-parent]="'#documentocollapse'"
              class="collapsed"  (click)="getDocumentoHtml(documento.idDocumento, documentoPanel)"><span>Apri</span>
              </a>
              <!--{{documento.famiglia}} - {{documento.sottoFamiglia}}-->
              <div class="col-sm-9 riepilogo">
                <div class="family">
                  <span class="strong">{{documento.famiglia}}</span> 
                  <span class="pipe">|</span>
                  <i>{{documento.sottoFamiglia}}</i>
                </div>              
                <div style="padding: 0" [innerHTML]="documento.text1" ></div>
                <!--                
                <div [innerHTML]="documento.text2" ></div>
                <p class="sintesi">{{(documento.abstract?.length>150)? (documento.abstract | slice:0:90)+'...':(documento.abstract)}}</p>
                -->                
              </div>
              <p class="col-sm-1" style="padding-left: 15px; font-size: 18px !important;" *ngIf="documento.url">
                <a title="Visualizza documento" href="{{documento.url}}" target="blank"><span
                    class="glyphicon glyphicon-file"></span></a>
              </p>
              <p class="col-sm-1" style="padding-left: 15px; font-size: 18px !important;" *ngIf="!documento.url">
                <a title="Visualizza documento" href="javascript:void(0)" style="color: grey;"><span
                class="glyphicon glyphicon-file"></span></a>
              </p>
              <p class="col-sm-1" style="padding-left: 15px; font-size: 18px !important;"
                *ngIf="documento.extension != 'HTML'">
                <a title="Aggiungi alla sezione documentale" href="javascript:void(0)"
                  (click)="importDoc(documento.idDocumento)"><span class="glyphicon glyphicon-download-alt"></span></a>
              </p>
              <p class="col-sm-1" style="padding-left: 15px; font-size: 18px !important;"
                *ngIf="documento.extension === 'HTML'">
                <a title="Aggiungi alla sezione documentale" href="javascript:void(0)"><span
                    class="glyphicon glyphicon-download-alt" style="color: grey;"></span></a>
              </p>
              <p class="col-sm-1">
                Data: <strong>{{ documento.data | date:'dd/MM/yyyy' }}</strong>
              </p>
            </div>
          </div>
          <ul class="collapse subcontroparte" id="subdocumento{{i}}" #documentoPanel>
            <li>
              <div class="row container_fieldset">
                <fieldset class="form-group">
                  <legend>Sintesi</legend>
                  <p style="padding: 10px;">{{documento.abstract}}</p>
                </fieldset>
              </div>
              <div class="row container_fieldset">
                <fieldset class="form-group">
                  <legend>Documento</legend>
                  <p style="padding: 10px;" [innerHtml]="text1"></p>
                  <p style="padding: 10px;" [innerHtml]="text2"></p>
                  <p style="padding: 10px;" [innerHtml]="content"></p>
                </fieldset>
              </div>
            </li>
          </ul>
        </li>
      </ng-template>
    </ul>
    <div *ngIf="sole24OreResponse.documents?.length > 0" class="standardpanel">
      <div class="row">
        <p *ngIf="sole24OreResponse.totalDocument > sole24OreResponse.documents.length" class="allinea_centro col-sm-12"
          style="padding: 0px;">
          <a href="javascript:void(0);" (click)="reloadSearch()"> <strong>Carica
              altri risultati</strong></a>
        </p>
        <p *ngIf="sole24OreResponse.totalDocument <= sole24OreResponse.documents.length"
          class="allinea_centro col-sm-12" style="padding: 0px;">
          <strong>Risultati totali
            {{sole24OreResponse.totalDocument}}</strong>
        </p>
        <p *ngIf="sole24OreResponse.totalDocument > sole24OreResponse.documents.length" class="allinea_centro col-sm-12"
          style="padding: 0px;">
          <strong>Risultati
            {{sole24OreResponse.documents.length}} di
            {{sole24OreResponse.totalDocument}}</strong>
        </p>
      </div>
    </div>
  </ng-template>
  <ng-template [ngIf]="sole24OreResponse && sole24OreResponse.documents.length === 0">
    <br>
    <br>
    <div class="row">
      <p class="allinea_centro coll-sm-12">
        <strong>La ricerca non ha prodotto risultati</strong>
      </p>
    </div>
  </ng-template>
</ng-template>

<!--<app-dettaglio-sole24-ore class="modal fade" id="dettaglio" tabindex="-1" role="dialog" style="display: none;"
  #dettaglioModal></app-dettaglio-sole24-ore>-->